import React, { FC, MutableRefObject, useRef } from 'react';
import classNames from 'classnames';
import { INSTABOOK_CAPTAIN_PRICE_FIELD } from 'src/calendar/constants';
import LoadingSpinner from 'src/common/components/LoadingSpinner';
import getClassName from 'src/common/utils/getClassName';
import Card from '../presentation/Card';
import PriceItem from '../PriceItem';
import styles from './PriceEditor.module.scss';

type PriceEditorProps = {
  amountFieldRef?: MutableRefObject<HTMLInputElement>;
  currencySymbol: string;
  captainCostEnabled?: boolean;
  isBaseCostLoading?: boolean;
};

const PriceEditor: FC<PriceEditorProps> = ({
  amountFieldRef,
  currencySymbol,
  captainCostEnabled,
  isBaseCostLoading,
}: PriceEditorProps) => {
  const captainAmountFieldRef = useRef<HTMLInputElement>();

  return (
    <Card>
      <div className={styles.root}>
        <div className={styles.baseCostContainer}>
          <div className={getClassName(
            styles,
            'baseCostItem',
            classNames({ loading: isBaseCostLoading }),
          )}
          >
            <PriceItem
              amountFieldRef={amountFieldRef}
              currencySymbol={currencySymbol}
              fieldName="subtotal"
              readOnly={isBaseCostLoading}
            >
              <strong className={styles.label}>
                Base Cost
              </strong>
            </PriceItem>
          </div>
          {isBaseCostLoading && (
            <div className={getClassName(
              styles,
              'loadingSpinner',
              classNames({ centered: !captainCostEnabled }),
            )}
            >
              <LoadingSpinner
                variant="xs"
                spinnerOnly
                noMargin
              />
            </div>
          )}
        </div>

        {captainCostEnabled && (
          <PriceItem
            amountFieldRef={captainAmountFieldRef}
            currencySymbol={currencySymbol}
            fieldName={INSTABOOK_CAPTAIN_PRICE_FIELD}
          >
            <strong className={styles.label}>
              Captain Cost
            </strong>
          </PriceItem>
        )}
      </div>
    </Card>
  );
};

export default PriceEditor;
